import {ChangeEvent, useState} from 'react';
import './_page-13.scss';
import {Form} from "react-bootstrap";
import useVMStore from "../../../../store";

export default function Page13() {
    const name = 'page13';

    const {data, setData} = useVMStore();

    const _data = data[name];

    const limitSize = 20 * 1024 * 1024;

    const [exceededSizeFiles, SetExceededSizeFiles] = useState<string[]>([]);

    function uploadFile(e: ChangeEvent<HTMLInputElement>) {
        SetExceededSizeFiles([]);
        const files = e.target.files;
        if (files && files.length) {
            const _files: File[] = [..._data.files];
            let _exceededSizeFiles: string[] = [];
            let size = _files.map(f => f.size).reduce((acc, cur) => acc + cur, 0);
            Array.from(files).forEach(f => {
                size += f.size;
                if (size < limitSize) {
                    _files.push(f);
                } else {
                    _exceededSizeFiles.push(f.name);
                }
            })
            if (_exceededSizeFiles.length) {
                SetExceededSizeFiles(_exceededSizeFiles);
            }
            setData({files: _files}, "page13");
        }
    }

    function deleteFile(idx: number) {
        const temp = [..._data.files];
        temp.splice(idx, 1);
        setData({files: temp}, 'page13');
    }

    return (
        <div className='page-13 d-flex flex-column align-items-center'>
            <Form>
                <div className='vm-input-file justify-content-between align-items-center'>
                    <span>Dateien hierher ziehen (Max. Dateigrösse: 20 MB)</span>
                    <div className='highlighted-btn vm-rounded text-center' style={{padding: '0.75em'}}>
                        <span>Dateien wählen</span>
                    </div>
                    <input type="file" multiple={true} onChange={uploadFile}/>
                </div>
            </Form>
            <p className={'w-100 ps-3 pt-3 mb-0 text-danger' + (exceededSizeFiles.length ? '' : ' d-none')}>
                {
                    'Die Gesamtgröße hat 20 MB überschritten (' + exceededSizeFiles.join(', ') + ')'
                }
            </p>
            <p className='pt-3 ps-3 w-100'>
                {/* Sollten Sie mehr als 20 MB hochladen wollen, können Sie dies gerne unter <a href="https://vermessung-digital.wetransfer.com/" target='_blank' rel="noreferrer noopener">www.vermessungdigital.wetransfer.com</a> tun */}
                Größer nutzen Sie <a href="https://vmts.wetransfer.com/" target='_blank' rel="noreferrer noopener">unsere WeTransfer!</a>
            </p>
            {
                _data.files.length ?
                    <div className='vm-input-file mt-3'>
                        <ol>
                            {
                                _data.files.map((f, idx) => (
                                    <li key={f.name + '_' + idx}>
                                        <div className='d-flex align-items-center'>
                                            <span>{f.name}</span>
                                            <button onClick={() => deleteFile(idx)}>
                                                <img src={process.env.REACT_APP_ROOT_DIRECTORY + "assets/images/del.svg"} alt="Del"/>
                                            </button>
                                        </div>
                                    </li>
                                ))
                            }
                        </ol>
                    </div> : ''
            }
        </div>
    );
}

